// "table_init": [
//   {
//     "key": "platform_BIG",
//     "title": "大屏",
//     "compatibleDevices": [],
//     "options": [],
//     "checked": false
//   },
//   {
//     "key": "platform_3C",
//     "title": "3C数码",
//     "compatibleDevices": [],
//     "options": [],
//     "checked": false
//   },
//   {
//     "key": "platform_central_control",
//     "title": "中控设备",
//     "compatibleDevices": [],
//     "options": [],
//     "checked": false
//   },
//   {
//     "key": "platform_educational_hardware",
//     "title": "教育硬件",
//     "compatibleDevices": [],
//     "options": [],
//     "checked": false
//   },
//   {
//     "key": "platform_Intelligent_network",
//     "title": "智能网络",
//     "compatibleDevices": [],
//     "options": [],
//     "checked": false
//   },
//   {
//     "key": "platform_drone",
//     "title": "无人机",
//     "compatibleDevices": [],
//     "options": [],
//     "checked": false
//   },
//   {
//     "key": "platform_screen_cast",
//     "title": "投屏设备",
//     "compatibleDevices": [],
//     "options": [],
//     "checked": false
//   },
//   {
//     "key": "platform_KIT",
//     "title": "开发套件",
//     "compatibleDevices": [],
//     "options": [],
//     "checked": false
//   }
// ],

import React, { useEffect, useState, useRef } from "react";
import {
  Button,
  Tabs,
  message,
  Form,
  Input,
  Upload,
  Select,
  Table,
  Space,
  Modal,
  Divider,
  Checkbox,
  Cascader,
  Progress,
} from "antd";
import type { RcFile, UploadFile, UploadProps } from "antd/es/upload/interface";
import type { UploadChangeParam } from "antd/es/upload";
import type { ColumnsType } from "antd/es/table";
import type { CheckboxProps, TabsProps } from "antd";
import {
  LoadingOutlined,
  PlusSquareFilled,
  CloudUploadOutlined,
  CloseCircleFilled,
  CheckCircleFilled,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { cloneDeep, delay } from "lodash-es";
import { useSelector } from "react-redux";
import StickyBox from "react-sticky-box";
import api from "@/api";
import { format, findDeep, changeSize, getReleaseDetail, arraysAreEqual } from "@/utils";
import { appNameReg } from "@/utils/constant";
import { uploadBaseUrl } from "@/api/release";
import ApplyDown from "./ApplyDown";

import dataJson from "@/../public/data.json";

const prefix = "release";
import "./index.less";
import { getServiceVal } from "@/utils/cookies";


type Props = {
  type: any;
  id: any;
  rId: any;
};
const Release: React.FC<Props> = (props: Props) => {
  const { type, id, rId } = props;
  const {
    release,
    staging,
    app_detail,
    please_enter,
    please_choose,
    icon_text,
    one_bars,
    two_bars,
    please_upload,
    save_text,
    save_success_text,
    req_err,
    cancelText,
    confirmText,
    increase,
    clear_text,
    asterisk,
    name_label,
    description_label,
  } = dataJson;
  const [activeKey, setActiveKey] = useState("1");
  const [previewData, setPreviewData] = useState<any[]>([]);
  const [iconLoading, setIconLoading] = useState(false);
  const [iconImageUrl, setIconImageUrl] = useState<string>();
  const [domainOption, setDomainOption] = useState<any[]>([]);
  const [topicOption, setTopicOption] = useState<any[]>([]);
  const [tableData, setTableData] = useState<any[]>(release.table_init);
  const [selectedKeys, setSelectedKeys] = useState<any[]>([]);
  const dataSource = useRef<any[]>(release.table_init); // 所有table数据，软件包类型切换时候只对应其中的部分内容展示，注意记录所有项的选中效果
  const detailData = useRef<any>();

  const packageType = useRef<string>("");
  const [packageData, setPackageData] = useState<any>();
  const [packageLoading, setPackageLoading] = useState(false);
  const [packageDataList, setPackageDataList] = useState<any[]>(release.package_data_list);
  const [copyrightImage, setCopyrightImage] = useState<any[]>([]);
  const [copyrightLoading, setCopyrightLoading] = useState(false);
  const [agreeCheck, setAgreeCheck] = useState(false);
  const [isBaseFinish, setIsBaseFinish] = useState(false);
  const [isVersionFinish, setIsVersionFinish] = useState(false);
  const [versionOptions, setVersionOptions] = useState<any[]>([]); //兼容KaihongOS版本
  const [uploadProgress, setUploadProgress] = useState<number>(0);

  const [applyDownVisible, setApplyDownVisible] = useState(false);

  const releaseDetail = useSelector((state: any) => state.releaseDetail);

  const previewInit = release.table_init.map((item: any) => ({
    key: item.key,
    title: item.title,
    description: "",
    osIds: [],
    list: [],
  }));
  const preview = useRef<any[]>(previewInit); // 存放所有预览图信息

  const navigate = useNavigate();

  const [baseForm] = Form.useForm();
  const baseFormValues = Form.useWatch([], baseForm);

  const [versionForm] = Form.useForm();
  const versionFormValues = Form.useWatch([], versionForm);

  const uploadUrl = `${uploadBaseUrl}/app/upload/public/${rId}`;

  const typeObj: any = app_detail.type_obj;
  const typeItem = typeObj[type!];
  const isComponent = type === staging.my_tabs[1].typeKey;

  const onChange = (key: string) => {
    setActiveKey(key);
  };

  const renderBtn = (item: string) => {
    const newShowMode =
      detailData.current?.histories?.length > 1 && detailData.current?.histories[0]?.showMode === "AUDIT_UPGRADE";
    switch (item) {
      case "save":
        return (
          <Button type="primary" ghost style={{ marginLeft: "16px" }} onClick={handleSave}>
            {save_text}
          </Button>
        );
        break;
      case "submitReview":
        return (
          <Button type="primary" style={{ marginLeft: "16px" }} onClick={submitReview}>
            {release.submit_review}
          </Button>
        );
        break;
      case "cancelRelease":
        return (
          <Button type="primary" style={{ marginLeft: "16px" }} onClick={cancelRelease}>
            {release.cancel_release}
          </Button>
        );
        break;
      case "upgrade":
        // 未升级情况，下架审核中的状态没有版本提交按钮，已升级的情况，下架审核中的状态有版本提交按钮，点击后跳转到新版本
        if (detailData.current?.histories?.length == 1 && detailData.current?.showMode === "AUDIT_DOWN") {
          break;
        }
        return (
          <Button type="primary" style={{ marginLeft: "16px" }} onClick={upgrade}>
            {release.upgrade}
          </Button>
        );
        break;
      case "down":
        if (newShowMode) {
          break;
        }
        return (
          <Button
            type="primary"
            ghost
            style={{ marginLeft: "16px" }}
            onClick={() => {
              setApplyDownVisible(true);
            }}
          >
            {release.audit_down}
          </Button>
        );
        break;
      case "cancelDown":
        return (
          <Button type="primary" style={{ marginLeft: "16px" }} onClick={cancelDown}>
            {release.cancel_down}
          </Button>
        );
        break;
      default:
        return;
    }
  };

  const renderTabBar: TabsProps["renderTabBar"] = (props, DefaultTabBar) => (
    <StickyBox offsetTop={0} offsetBottom={20} style={{ zIndex: 99, background: "#fff", paddingTop: 24 }}>
      <DefaultTabBar {...props} />
    </StickyBox>
  );

  // 校验用户名
  const vailIdName = (_: any, value: any) => {
    if (value) {
      if (value !== detailData.current.name) {
        return api[typeItem.vailIdNameApi]({ name: value, id: rId }).then((resp: any) => {
          if (resp.code === 200) {
            if (resp.data?.exist) {
              const nameRepeatMsg: any = staging.name_repeat_msg;
              const errMsg =
                typeof nameRepeatMsg[resp.data?.type] === "string"
                  ? nameRepeatMsg[resp.data?.type]
                  : nameRepeatMsg[resp.data?.type][resp.data?.subType[0]];

              return Promise.reject(new Error(errMsg));
            }
          } else {
            return Promise.resolve();
          }
        });
      } else {
        return Promise.resolve();
      }
    } else {
      return Promise.resolve();
    }
  };

  // 预览数据从树状转化成平铺
  const flatPreviewData = (params: any) => {
    return new Promise<void>((resolve) => {
      const list: any = [];

      params?.forEach((item: any) => {
        item.list.forEach((ele: any) => {
          const reqOsIds = ele?.osIds.map((item: any) => item[1]);
          const pictureIds = ele?.urlList.map((e: any) => e.id);
          const obj = {
            description: ele?.description || "",
            osIds: reqOsIds || [],
            id: ele?.dictCode,
            pictureIds: pictureIds,
          };
          list.push(obj);
        });
      });
      const effectiveList = list.filter((item: any) => {
        // return item.description || item.pictureIds?.length > 0;
        return item?.osIds?.length || item?.pictureIds?.length;
      });
      resolve(effectiveList);
    });
  };

  const scrollErrDom = (domClass: string, delayTime?: number) => {
    if (delayTime) {
      delay(() => {
        const errorList = (document as any).querySelectorAll(domClass);
        //由于校验失败ant会自动给失败表单项添加类名，直接获取即可
        errorList[0].scrollIntoView({
          block: "center",
          behavior: "smooth",
        });
      }, delayTime);
    } else {
      const errorList = (document as any).querySelectorAll(domClass);
      //由于校验失败ant会自动给失败表单项添加类名，直接获取即可
      errorList[0].scrollIntoView({
        block: "center",
        behavior: "smooth",
      });
    }
  };

  // 处理请求参数
  const handleReq = async (isValidate: boolean) => {
    let baseValues: any;
    let versionValues: any;

    if (isValidate) {
      if (activeKey === "1") {
        try {
          baseValues = await baseForm.validateFields();
        } catch (error) {
          scrollErrDom(".ant-form-item-has-error", 100);
          return;
        }

        if (baseValues) {
          try {
            versionValues = await versionForm.validateFields();
          } catch (error) {
            setActiveKey("2");
            scrollErrDom(".ant-form-item-has-error", 300);
            return;
          }
        }
      } else {
        try {
          baseValues = await baseForm.validateFields();
        } catch (error) {
          setActiveKey("1");
          scrollErrDom(".ant-form-item-has-error", 300);
          return;
        }
        if (baseValues) {
          try {
            versionValues = await versionForm.validateFields();
          } catch (error) {
            scrollErrDom(".ant-form-item-has-error", 100);
            return;
          }
        }
      }
    } else {
      baseValues = await baseForm.getFieldsValue();
      versionValues = await versionForm.getFieldsValue();
    }

    try {
      const supportDevices = await flatPreviewData(previewData);
      const resourcesArr = [];
      const copyrightIds = versionValues?.copyright?.map((item: any) => item.id);
      copyrightIds?.length &&
        resourcesArr.push({
          resourceIds: copyrightIds,
          type: "CERTIFICATE_PICTURE",
        });
      const iconIds = baseValues?.iconResources;
      !!iconIds &&
        resourcesArr.push({
          resourceIds: [iconIds],
          type: "ICON",
        });
      const instanceResourcesFilter = versionValues?.instanceResources?.filter((item: any) => item.resourceId);
      const instanceResourcesIds = instanceResourcesFilter?.map((item: any) => item.instanceId);

      const req = {
        description: baseValues?.description,
        domain: baseValues?.domain ? [baseValues?.domain] : [],
        topic: baseValues?.topic,
        id: rId,
        name: baseValues?.name,
        introduction: baseValues?.introduction,
        instanceIds: isComponent
          ? instanceResourcesIds
          : versionValues?.instanceIds?.instanceId
          ? [versionValues?.instanceIds?.instanceId]
          : [],
        privacy: versionValues?.privacy,
        resources: resourcesArr,
        supportDevices,
      };
      return req;
    } catch (errorInfo: any) {
      console.error(errorInfo);
      return;
    }
  };

  const handleSave = async () => {
    const req = await handleReq(false);

    if (req) {
      try {
        const res: any = await api[typeItem.saveApi](req);

        if (res?.code == 200) {
          window.message.success(save_success_text);
          // getReleaseDetail(type, rId);
        } else {
          window.message.error(res.msg);
        }
      } catch (errorInfo: any) {
        window.message.error(errorInfo?.response?.data?.msg || req_err);
      }
    }
  };

  // 提交审核
  const submitReview = async () => {
    const req = await handleReq(true);

    if (req) {
      if (!isComponent && !versionFormValues.agree) {
        window.message.error(release.please_check_agree);
        if (activeKey === "1") {
          setActiveKey("2");
          scrollErrDom(".release-versionForm-agree", 300);
        } else {
          scrollErrDom(".release-versionForm-agree");
        }
        return;
      }
      try {
        const res: any = await api[typeItem.nextSaveApi](req);
        if (res?.code == 200) {
          // 接口区分原子化和应用，还要区分是否是升级的提交
          const res2: any = await api[
            detailData.current?.isUpgrade ? typeItem.auditUpgradeApi : typeItem.auditReleaseApi
          ]({ id: rId });
          if (res2?.code == 200) {
            window.message.success(release.wait_review);
            getReleaseDetail(type, rId);
          } else {
            window.message.error(res2.msg);
          }
        } else {
          window.message.error(res.msg);
        }
      } catch (errorInfo: any) {
        window.message.error(errorInfo?.response?.data?.msg || req_err);
      }
    }
  };

  const cancelRelease = async () => {
    const modal = Modal.confirm({
      icon: null,
      centered: true,
      closable: true,
      width: 350,
      title: release.cancel_release_title,
      content: release.cancel_release_content,
      footer: (
        <div style={{ textAlign: "right", marginTop: "20px" }}>
          <Button
            type="primary"
            ghost
            onClick={() => {
              modal.destroy();
            }}
          >
            {cancelText}
          </Button>
          <Button
            type="primary"
            style={{ marginLeft: "24px" }}
            onClick={async () => {
              try {
                const res: any = await api[
                  detailData.current?.isUpgrade ? typeItem.cancelUpgradeApi : typeItem.cancelReleaseApi
                  // type === "2"
                  //   ? detailData.current?.isUpgrade
                  //     ? "appCancelUpgrade"
                  //     : "appCancelRelease"
                  //   : detailData.current?.isUpgrade
                  //   ? "atomicCancelUpgrade"
                  //   : "atomicCancelRelease"
                ]({ id: rId });

                if (res?.code == 200) {
                  window.message.success(release.cancel_release_success);
                  getReleaseDetail(type, rId);
                  modal.destroy();
                } else {
                  window.message.error(res.msg);
                }
              } catch (errorInfo: any) {
                window.message.error(errorInfo?.response?.data?.msg || req_err);
              }
            }}
          >
            {confirmText}
          </Button>
        </div>
      ),
    });
  };

  const upgrade = async () => {
    if (detailData.current?.histories?.length > 1) {
      navigate(`/app_detail/new/${type}/${id}?rId=${detailData.current?.histories[0].id}`);
    } else {
      try {
        const res: any = await api[typeItem.upgradeApi]({ id: rId });
        if (res?.code == 200) {
          navigate(`/app_detail/new/${type}/${id}?rId=${res.data.id}`);
          getReleaseDetail(type, res.data.id);
        } else {
          window.message.error(res.msg);
        }
      } catch (errorInfo: any) {
        window.message.error(errorInfo?.response?.data?.msg || req_err);
        return;
      }
    }
  };

  const cancelDown = async () => {
    const modal = Modal.confirm({
      icon: null,
      centered: true,
      closable: true,
      width: 350,
      title: release.cancel_down,
      content: release.cancel_down_content,
      footer: (
        <div style={{ textAlign: "right", marginTop: "20px" }}>
          <Button
            type="primary"
            ghost
            onClick={() => {
              modal.destroy();
            }}
          >
            {cancelText}
          </Button>
          <Button
            type="primary"
            style={{ marginLeft: "24px" }}
            onClick={async () => {
              try {
                const res: any = await api[typeItem.cancelDownApi]({ id: rId });

                if (res?.code == 200) {
                  window.message.success(release.cancel_down_success);
                  getReleaseDetail(type, rId);
                  modal.destroy();
                } else {
                  window.message.error(res.msg);
                }
              } catch (errorInfo: any) {
                window.message.error(errorInfo?.response?.data?.msg || req_err);
              }
            }}
          >
            {confirmText}
          </Button>
        </div>
      ),
    });
  };

  const applyDownClose = () => {
    setApplyDownVisible(false);
    getReleaseDetail(type, rId);
  };

  // 设置全数据
  const setPreviewCurrent = (params: any) => {
    const newPreview = preview.current.map((item: any) => {
      const previewItem = params?.find((ele: any) => item.key == ele.key);
      return previewItem ? previewItem : item;
    });

    preview.current = newPreview.filter((item: any) => Object.prototype.toString.call(item) != "[object String]");
  };

  // 初始化数据
  const initHandle = async (tableParams: any[]) => {
    const dataCopy = cloneDeep(detailData.current);

    let packObj = null;
    let packList: any[] = [];
    if (isComponent) {
      const packageDataListCopy = cloneDeep(release.package_data_list);
      packList = packageDataListCopy.map((item) => {
        const resPackageResource = dataCopy?.appInstances.find((ele: any) => item.type == ele.type);

        if (resPackageResource) {
          return {
            ...item,
            //已下架的状态，如果有其中一个软件包未上传，可以继续上传，其余情况都和其他状态一致
            disabled: resPackageResource.instanceId && dataCopy?.packageDisabled,
            ...resPackageResource.packageResource,
            version: resPackageResource.version,
            instanceId: resPackageResource.instanceId,
          };
        } else {
          return {
            ...item,
            //已下架的状态，如果有其中一个软件包未上传，可以继续上传，其余情况都和其他状态一致
            disabled: dataCopy?.packageDisabled
              ? dataCopy?.allowChangePackageList
                ? false
                : dataCopy?.packageDisabled
              : dataCopy?.packageDisabled,
          };
        }
      });
    } else {
      packObj = dataCopy?.appInstances?.length
        ? {
            ...dataCopy?.appInstances[0]?.packageResource,
            version: dataCopy?.appInstances[0]?.version,
            instanceId: dataCopy?.appInstances[0]?.instanceId,
          }
        : null;
    }

    const iconItem = dataCopy?.resources?.find((item: any) => item.type == "ICON");

    const hasPreviewFormData = !!dataCopy?.support?.compatibilities?.length;

    const tableDataCopy = cloneDeep(tableParams);
    const newTableDataCopy = tableDataCopy.map((item: any) => {
      const itemList = dataCopy?.support?.compatibilities?.filter((ele: any) => ele.type == item.key) || [];
      const idList = itemList?.map((ele: any) => ele.id);
      if (idList?.length) {
        item.compatibleDevices = idList;
      }
      return item;
    });
    dataSource.current = newTableDataCopy;

    const list = newTableDataCopy.filter((item: any) => {
      //// 数字孪生取大屏，非数字孪生取其他
      // return type === "3" ? item.key === "platform_BIG" : item.key !== "platform_BIG";
      return item.key !== "platform_BIG";
    });
    const initTableData: any[] = tableDataCopy.map((item: any) => {
      const itemList = dataCopy?.support?.compatibilities?.filter((ele: any) => ele?.type == item?.key) || [];

      const objList = itemList.map((ele: any) => {
        const objUrlList = ele.resources.map((e: any) => {
          return {
            id: e.id,
            url: e.url,
            loading: false,
          };
        });
        const osIdsArr = ele.osVersions.map((e: any) => [e.type, e.id]);

        const objItem = {
          dictCode: ele.id || "",
          loading: false,
          title: ele?.title || "",
          description: ele?.description || "",
          osIds: osIdsArr || [],
          urlList: objUrlList,
        };
        return objItem;
      });

      const obj = {
        key: item.key,
        title: item.title,
        list: objList,
      };
      return obj;
    });

    const initPreviewData = initTableData?.filter((item: any) => item?.list?.length);
    setPreviewCurrent(initPreviewData);
    let initSelectedKeys = initPreviewData.map((item: any) => item.key);
    if (!hasPreviewFormData) {
      initSelectedKeys = [list[0].key];
    }

    const copyrightList = dataCopy.resources
      .filter((item: any) => item.type == "CERTIFICATE_PICTURE")
      .map((item: any) => ({ id: item.id, url: item.url }));

    baseForm.setFieldsValue({
      name: dataCopy?.name || "",
      introduction: dataCopy?.introduction || "",
      description: dataCopy?.description || "",
      iconResources: iconItem?.id || "",
      domain: dataCopy?.domain?.length ? dataCopy?.domain[0] : undefined,
      topic: dataCopy?.topic || [],
      previewFormData: [],
    });

    versionForm.setFieldsValue({
      instanceIds: packObj,
      instanceResources: packList,
      iconResources: iconItem?.id || "",
      privacy: dataCopy?.privacy,
      agree: false,
      copyright: copyrightList,
      previewFormData: [],
    });

    setPackageData(packObj);
    setPackageDataList(packList);
    setIconImageUrl(iconItem?.url);
    setSelectedKeys(initSelectedKeys);
    setTableData(list);
    setCopyrightImage(copyrightList);
    setAgreeCheck(false);
    // setPreviewData(initPreviewData);
  };

  // 获取不同设备类型的可兼容设备
  const getSupportOptions = () => {
    const typeList = release.table_init.map((item: any) => item.key);
    const hasPreviewFormData = !!releaseDetail?.support?.compatibilities?.length;
    const promises = typeList.map(async (item: any) => {
      return await getOptions(item);
    });

    Promise.all(promises)
      .then(async (posts) => {
        const tableCopy = cloneDeep(release.table_init).map((item: any, index: number) => {
          // 初始值，默认选中第一行第一项
          // if (!hasPreviewFormData && ["platform_BIG", "platform_3C"].includes(item.key)) {
          if (!hasPreviewFormData && ["platform_3C"].includes(item.key)) {
            item.checked = true;
            item.compatibleDevices = [posts[index][0].dictCode];
          }
          return {
            ...item,
            options: posts[index],
          };
        });
        initHandle(tableCopy);
      })
      .catch(() => {
        // ...
      });
  };

  // 可兼容设备改变事件，注意对应设备类型和列表的row数据
  const compatibleChange = (value: string[], key: string) => {
    const tableDataCopy = cloneDeep(tableData);
    const newData = tableDataCopy.map((item: any) => {
      if (key == item.key) {
        item.compatibleDevices = value;
      }
      return item;
    });
    setTableData(newData);
  };

  // table列
  const getTableColumns: () => ColumnsType<any> = () => {
    const tableColumns = cloneDeep(release.table_columns);
    const columnsList = tableColumns.map((item: any) => {
      if (item.dataIndex === "compatibleDevices") {
        return {
          ...item,
          render: (_: any, record: any) => {
            return (
              <Space size="middle" key={record.key}>
                <Select
                  mode="multiple"
                  showSearch={false}
                  value={_}
                  style={{ minWidth: "70px" }}
                  dropdownStyle={{ minWidth: 150 }}
                  placeholder={increase}
                  fieldNames={{ label: "dictLabel", value: "dictCode" }}
                  onChange={(e) => {
                    compatibleChange(e, record.key);
                  }}
                  options={record.options}
                  tagRender={(params) => {
                    // 多选时候每个选项选中后对应展示的内容
                    const le = record?.compatibleDevices?.length || 0;
                    const text =
                      record?.compatibleDevices[le - 1] == params.value ? params.label : params.label + "\xa0/\xa0";
                    return <span>{text}</span>;
                  }}
                  disabled={!selectedKeys.includes(record.key) || detailData.current?.disabled}
                  className={`${prefix}-device-select`}
                  popupClassName={`${prefix}-device-select-popup`}
                />
              </Space>
            );
          },
        };
      } else if (item.dataIndex === "action") {
        return {
          ...item,
          render: (_: any, record: any) => {
            const tableDataCopy = cloneDeep(tableData);
            const tableChecks = tableDataCopy.filter((item: any) => selectedKeys?.includes(item.key));
            const allCompatibleDevices = tableChecks.reduce((pre: any, cur: any) => {
              return [...pre, ...cur.compatibleDevices];
            }, []);
            const checkDisabled = arraysAreEqual(allCompatibleDevices, record.compatibleDevices); // 选中的所有可兼容设备被都在当前选中行

            return (
              <Space size="middle" key={record.key}>
                <Button
                  type="link"
                  onClick={() => {
                    compatibleChange([], record.key);
                  }}
                  disabled={checkDisabled || detailData.current?.disabled}
                >
                  {clear_text}
                </Button>
              </Space>
            );
          },
        };
      } else {
        return item;
      }
    });
    return columnsList;
  };

  // 多选事件
  const rowSelection = {
    // 对应的选项
    selectedRowKeys: selectedKeys,
    // 选中项发生变化时
    onChange: (selectedRowKeys: React.Key[]) => {
      setSelectedKeys(selectedRowKeys);
    },
    // 手动选择/取消选择某行
    onSelect: (record: any, selected: any) => {
      dataSource.current.forEach((item: any) => {
        if (record.key == item.key) {
          item.checked = selected;
        }
      });
    },
    // 手动选择/取消选择所有行
    onSelectAll: (selected: any, selectedRows: any, changeRows: any) => {
      dataSource.current.forEach((item: any) => {
        if (changeRows.key == item.key) {
          item.checked = !item.checked;
        }
      });
    },
    getCheckboxProps: (record: any) => {
      let checkDisabled = false;
      const oneCheck = selectedKeys.length === 1; //只有一行被选中
      if (oneCheck) {
        const thisCheck = selectedKeys[0] === record.key; //选中的是当前这行
        checkDisabled = oneCheck && thisCheck; // 仅有一个选中时候不允许取消，保证有一个选中
      } else {
        const tableDataCopy = cloneDeep(tableData);
        const tableChecks = tableDataCopy.filter((item: any) => selectedKeys?.includes(item.key));
        const allCompatibleDevices = tableChecks.reduce((pre: any, cur: any) => {
          return [...pre, ...cur.compatibleDevices];
        }, []);
        checkDisabled = arraysAreEqual(allCompatibleDevices, record.compatibleDevices); // 选中的所有可兼容设备被都在当前选中行
      }

      return {
        disabled: detailData.current?.disabled || checkDisabled,
      };
    },
  };

  // 图片上传前处理
  const beforeUpload: any = (file: RcFile, { width, height, size, accept = ["png"] }: any) => {
    return new Promise<void>((resolve, reject) => {
      const isAccept = accept.some((item: string) => file.type === `image/${item}`);
      const acceptText = accept.join("、").toUpperCase();

      if (!isAccept) {
        window.message.error(
          `${release.upload_accept_err.text1}${width}${asterisk}${height}${release.upload_accept_err.text2}${acceptText}${release.upload_accept_err.text3}`
        );
        reject();
        return;
      }
      if (size) {
        const imgSize = file.size;
        if (imgSize > size) {
          const sizeText = changeSize(size);
          window.message.error(`${release.upload_size_err.text1}${sizeText}${release.upload_size_err.text2}`);
          reject();
          return;
        }
      }
      const _URL = window.URL || window.webkitURL;
      const img = new Image();
      img.src = _URL.createObjectURL(file);
      img.onload = function () {
        if (img.width != width || img.height != height) {
          window.message.error(
            `${release.upload_accept_err.text1}${width}${asterisk}${height}${release.upload_accept_err.text2}${acceptText}${release.upload_accept_err.text3}`
          );
          reject();
        } else {
          resolve();
        }
      };
    });
  };

  // 上传证书
  const copyrightBeforeUpload = (file: RcFile) => {
    const isType = ["image/jpg", "image/jpeg", "image/bmp", "image/png"].includes(file.type);
    if (!isType) {
      window.message.error(release.upload_copyright_err.type);
    }
    const isLt2M = file.size / 1024 / 1024 <= 10;
    if (!isLt2M) {
      window.message.error(release.upload_copyright_err.size);
    }
    return isType && isLt2M;
  };

  // 图标新增
  const iconImageChange: UploadProps["onChange"] = (info: UploadChangeParam<UploadFile>) => {
    if (info.file.status === "uploading") {
      setIconLoading(true);
      return;
    } else {
      setIconLoading(false);
    }
    if (info.file.status === "done") {
      if (info.file.response.code === 200) {
        const iconUrl = info?.file?.response?.data?.url;
        const iconId = info?.file?.response?.data?.id;

        setIconLoading(false);
        setIconImageUrl(iconUrl);
        baseForm.setFieldValue("iconResources", iconId);
      } else {
        window.message.error(info.file.response.msg);
      }
    } else {
      baseForm.setFieldValue("iconResources", "");
      setIconImageUrl("");
    }
    baseForm.validateFields(["iconResources"]);
  };
  // 预览图更换
  const previewImgUpdate = (info: UploadChangeParam<UploadFile>, index: number, idx: number, i: number) => {
    const previewDataCopy = cloneDeep(previewData);
    if (info.file.status === "uploading") {
      previewDataCopy[index].list[idx].urlList[i].loading = true;
      setPreviewData(previewDataCopy);
      return;
    } else {
      previewDataCopy[index].list[idx].urlList[i].loading = false;
      setPreviewData(previewDataCopy);
    }
    if (info.file.status === "done") {
      if (info.file.response.code === 200) {
        previewDataCopy[index].list[idx].urlList[i].id = info?.file?.response?.data?.id;
        previewDataCopy[index].list[idx].urlList[i].url = info?.file?.response?.data?.url;
        previewDataCopy[index].list[idx].urlList[i].loading = false;
        setPreviewData(previewDataCopy);
      } else {
        window.message.error(info.file.response.msg);
      }
    } else {
      setPreviewData(previewDataCopy);
    }
    baseForm.validateFields(["previewFormData"]);
  };
  // 预览图删除
  const previewImgDelete = (index: number, idx: number, i: number) => {
    const previewDataCopy = cloneDeep(previewData);
    previewDataCopy[index].list[idx].urlList.splice(i, 1);
    setPreviewData(previewDataCopy);
    baseForm.validateFields(["previewFormData"]);
  };
  // 预览图新增
  const previewImgChange = (info: UploadChangeParam<UploadFile>, index: number, idx: number) => {
    const previewDataCopy = cloneDeep(previewData);
    if (info.file.status === "uploading") {
      previewDataCopy[index].list[idx].loading = true;
      setPreviewData(previewDataCopy);
      return;
    } else {
      previewDataCopy[index].list[idx].loading = false;
      setPreviewData(previewDataCopy);
    }
    if (info.file.status === "done") {
      if (info.file.response.code === 200) {
        previewDataCopy[index].list[idx].urlList.push({
          id: info?.file?.response?.data?.id,
          url: info?.file?.response?.data?.url,
          loading: false,
        });
        previewDataCopy[index].list[idx].loading = false;
        setPreviewData(previewDataCopy);
      } else {
        window.message.error(info.file.response.msg);
      }
    } else {
      setPreviewData(previewDataCopy);
    }
    baseForm.validateFields(["previewFormData"]);
  };
  // 软件包上传前处理
  const packageBeforeUpload = (file: RcFile) => {
    return new Promise<void>((resolve, reject) => {
      const isSizeOk = file.size <= typeItem.packageMaxSize;
      const isFileTypeOk = typeItem.packageNameEnd.some((item: string) => {
        const regex = new RegExp(`${item}$`, "i");
        return regex.test(file.name);
      });

      if (!isFileTypeOk) {
        window.message.error(typeItem.packageTypeErr);
        reject();
        return;
      }

      if (!isSizeOk) {
        if (type === staging.app_tabs[0].key) {
          if (file.name.endsWith(".hap")) {
            window.message.error(typeItem.hapPackageSizeErr);
            reject();
            return;
          } else {
            window.message.error(typeItem.appPackageSizeErr);
            reject();
            return;
          }
        } else {
          window.message.error(typeItem.packageSizeErr);
          reject();
          return;
        }
      }

      // 类型和大小都对了就结合包类型给type赋值
      const nameSplitArr = file.name.split(".");
      const typeName = nameSplitArr[nameSplitArr.length - 1];
      const typeReq = typeName.toUpperCase();
      packageType.current = typeReq;

      resolve();
    });
  };
  // 上传软件包
  const packageReq = async (options: any) => {
    setPackageLoading(true);
    const { file } = options;

    setPackageData({ ...packageData, name: file.name });

    const formData = new FormData();
    formData.append("file", file);
    formData.append("appId", rId);
    formData.append("type", packageType.current);
    formData.append("subType", packageType.current);
    try {
      api
        .uploadFile(formData, rId, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          // 上传进度回调
          onUploadProgress: (progressEvent: any) => {
            if (progressEvent?.progress) {
              const progressNumber = Math.floor(progressEvent?.progress * 100);
              setUploadProgress(progressNumber);
            }
          },
          errorIntercept: true,
        })
        .then((res: any) => {
          if (res.code !== 200) {
            window.message.error(res.msg);
            versionForm.setFieldValue("instanceIds", null);
          } else {
            setPackageData(res.data);
            versionForm.setFieldValue("instanceIds", res.data);
          }
        })
        .catch((err: any) => {
          window.message.error(err?.response?.data?.msg || release.upload_fail);
        })
        .finally(() => {
          setPackageLoading(false);
          versionForm.validateFields(["instanceIds"]);
          setUploadProgress(0);
        });
    } catch (err) {
      console.error(err);
      setPackageLoading(false);
    }
  };

  const handleInstanceResources = (listData: any[]) => {
    delay(() => {
      versionForm.setFieldValue("instanceResources", listData);
      versionForm.validateFields(["instanceResources"]);
    }, 0);
  };
  const packageListReq = (options: any, item: any) => {
    const { file } = options;

    setPackageDataList((oldData) => {
      return oldData.map((itemOld) => {
        if (itemOld.type === item.type) {
          return {
            ...itemOld,
            loading: true,
            name: file.name,
            uploadProgress: 0,
          };
        }
        return itemOld;
      });
    });

    const formData = new FormData();
    formData.append("file", file);
    formData.append("appId", rId);
    formData.append("type", item.type);
    try {
      api
        .uploadFile(formData, rId, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          // 上传进度回调
          onUploadProgress: (progressEvent: any) => {
            if (progressEvent?.progress) {
              const progressNumber = Math.floor(progressEvent?.progress * 100);
              setPackageDataList((oldData) => {
                return oldData.map((itemOld) => {
                  if (itemOld.type === item.type) {
                    return {
                      ...itemOld,
                      uploadProgress: progressNumber,
                    };
                  }
                  return itemOld;
                });
              });
            }
          },
          errorIntercept: true,
        })
        .then((res: any) => {
          if (res.code !== 200) {
            window.message.error(res.msg);
          } else {
            setPackageDataList((oldData) => {
              return oldData.map((itemOld) => {
                if (itemOld.type === item.type) {
                  return {
                    ...itemOld,
                    ...res.data,
                  };
                }
                return itemOld;
              });
            });
          }
        })
        .catch((err: any) => {
          window.message.error(err?.response?.data?.msg || release.upload_fail);
        })
        .finally(() => {
          setPackageDataList((oldList) => {
            const newList = oldList.map((oldItem) => {
              if (oldItem.type === item.type) {
                return {
                  ...oldItem,
                  loading: false,
                };
              }
              return oldItem;
            });
            handleInstanceResources(newList);
            return newList;
          });
        });
    } catch (err) {
      console.error(err);
      setPackageDataList((oldList) => {
        const newList = oldList.map((oldItem) => {
          if (oldItem.type === item.type) {
            return {
              ...oldItem,
              loading: false,
            };
          }
          return oldItem;
        });
        handleInstanceResources(newList);
        return newList;
      });
    }
  };
  // 删除软件包
  const packageDel = () => {
    setPackageData(null);
    versionForm.setFieldValue("instanceIds", null);
    versionForm.validateFields(["instanceIds"]);
  };
  const packageListDel = (item: any) => {
    setPackageDataList((oldList) => {
      const newList = oldList.map((oldItem) => {
        if (oldItem.type === item.type) {
          return { type: item.type, uploadLabel: item.uploadLabel, resourceId: "", loading: false };
        }
        return oldItem;
      });
      handleInstanceResources(newList);
      return newList;
    });
  };

  // 可兼容版本号：
  const previewDescriptionChange = (val: any, index: number, idx: number) => {
    const previewDataCopy = cloneDeep(previewData);
    previewDataCopy[index].list[idx].osIds = val;
    versionForm.setFieldValue(["previewFormData", index, "list", idx, "osIds"], val);
    setPreviewData(previewDataCopy);
    versionForm.validateFields(["previewFormData"]);
  };

  // 更换版权证书
  const copyrightImgUpdate = (info: UploadChangeParam<UploadFile>, index: number) => {
    const copyrightImageCopy = cloneDeep(copyrightImage);
    if (info.file.status === "uploading") {
      copyrightImageCopy[index].loading = true;
      setCopyrightImage(copyrightImageCopy);
      return;
    } else {
      copyrightImageCopy[index].loading = false;
      setCopyrightImage(copyrightImageCopy);
    }
    if (info.file.status === "done") {
      if (info.file.response.code === 200) {
        copyrightImageCopy[index].id = info?.file?.response?.data?.id;
        copyrightImageCopy[index].url = info?.file?.response?.data?.url;
        copyrightImageCopy[index].type = info?.file.response?.data?.type;
        copyrightImageCopy[index].loading = false;
        setCopyrightImage(copyrightImageCopy);
        versionForm.setFieldValue("copyright", copyrightImageCopy);
      } else {
        window.message.error(info.file.response.msg);
      }
    } else {
      versionForm.setFieldValue("copyright", copyrightImageCopy);
    }
    versionForm.validateFields(["copyright"]);
  };
  // 删除版权证书
  const copyrightImgDelete = (index: number) => {
    const copyrightImageCopy = cloneDeep(copyrightImage);
    copyrightImageCopy.splice(index, 1);
    setCopyrightImage(copyrightImageCopy);
    versionForm.setFieldValue("copyright", copyrightImageCopy);
    versionForm.validateFields(["copyright"]);
  };
  // 上传版权证书
  const copyrightImgChange = (info: UploadChangeParam<UploadFile>) => {
    if (info.file.status === "uploading") {
      setCopyrightLoading(true);
      return;
    } else {
      setCopyrightLoading(false);
    }
    if (info.file.status === "done") {
      if (info.file.response.code === 200) {
        const copyrightImageCopy = cloneDeep(copyrightImage);
        copyrightImageCopy.push({
          id: info?.file?.response?.data?.id,
          url: info?.file?.response?.data?.url,
          type: info?.file.response?.data?.type,
        });
        setCopyrightLoading(false);
        setCopyrightImage(copyrightImageCopy);
        versionForm.setFieldValue("copyright", copyrightImageCopy);
      } else {
        window.message.error(info.file.response.msg);
      }
    }
    versionForm.validateFields(["copyright"]);
  };

  const commitmentLetter = () => {
    Modal.info({
      icon: <span></span>,
      okText: confirmText,
      content: (
        <>
          <div style={{ textAlign: "center", fontSize: "24px" }}>{release.commitment_letter_text}</div>
          <div>{release.commitment_letter_content1}</div>
          <div>{release.commitment_letter_content2}</div>
        </>
      ),
    });
  };

  const agreeChange: CheckboxProps["onChange"] = (e: any) => {
    setAgreeCheck(e.target.checked);
    versionForm.setFieldValue("agree", e.target.checked);
  };

  const domainAndTopic = async () => {
    const domainList: any = await getOptions(typeItem.domainApiParam);
    setDomainOption(domainList);
    const topicList: any = await getOptions(typeItem.topicApiParam);
    setTopicOption(topicList);
  };

  // 应用领域、应用专题下拉项
  const getOptions = async (type: string) => {
    try {
      const res: any = await api.getDict(type);
      if (res?.code == 200) {
        return res?.data?.value || [];
      } else {
        window.message.error(res.msg);
      }
    } catch (errorInfo: any) {
      window.message.error(errorInfo?.response?.data?.msg || req_err);
    }
  };

  const getOSOptions = async (data: any) => {
    const promises = data.map((item: any) => {
      return new Promise((resolve, reject) => {
        const option: any = {
          label: item,
          value: item,
          children: [],
        };
        getOptions(item)
          .then((children) => {
            option.children = children.map((v: any) => {
              return { label: v["dictLabel"], value: v["dictCode"] };
            });
            resolve(option);
          })
          .catch(() => {
            reject(option);
          });
      });
    });
    return Promise.allSettled(promises);
  };

  // 兼容KaihongOS版本
  const getOSVersionList = async () => {
    try {
      const res: any = await api.componentOs();
      if (res.code === 200) {
        const data = res?.data || [];
        const resData: any = await getOSOptions(data);
        const list = resData.map((item: any) => {
          return item.value;
        });
        setVersionOptions([...list]);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    const tableDataCopy = cloneDeep(tableData);
    const tableChecks = tableDataCopy.filter((item: any) => selectedKeys?.includes(item.key));
    const allCompatibleDevices = tableChecks.reduce((pre: any, cur: any) => {
      return [...pre, ...cur.compatibleDevices];
    }, []);

    if (allCompatibleDevices?.length === 1) {
      for (let index = 0; index < tableDataCopy.length; index++) {
        const element = tableDataCopy[index];
        if (element?.compatibleDevices[0] === allCompatibleDevices[0]) {
          for (let ind = 0; ind < element?.options?.length; ind++) {
            const item = element.options[ind];
            if (item.dictCode === allCompatibleDevices[0] && !item?.disabled) {
              tableDataCopy[index].options[ind].disabled = true;
              setTableData(tableDataCopy);
              break;
            }
          }
          break;
        }
      }
    } else {
      for (let index = 0; index < tableDataCopy.length; index++) {
        const element = tableDataCopy[index];
        for (let ind = 0; ind < element?.options?.length; ind++) {
          const item = element.options[ind];
          if (item?.disabled) {
            tableDataCopy[index].options[ind].disabled = false;
            setTableData(tableDataCopy);
          }
        }
      }
    }

    const effectiveData = tableData.filter(
      (item: any) => item?.compatibleDevices?.length && selectedKeys.includes(item.key)
    );
    const newPreviewData = effectiveData.map((item: any) => {
      const effectiveOption = item?.options.filter((ele: any) => item.compatibleDevices.includes(ele.dictCode));

      const list = effectiveOption.map((ele: any) => {
        const previewItem = preview.current.find((e: any) => e.key == ele.dictType);
        const previewListItem = previewItem?.list?.find((e: any) => e.dictCode == ele.dictCode);
        const newUrlList = previewListItem?.urlList || [];

        return {
          dictCode: ele?.dictCode,
          dictValue: ele?.dictValue,
          dictLabel: ele?.dictLabel,
          description: previewListItem?.description,
          osIds: previewListItem?.osIds || [],
          loading: false,
          urlList: newUrlList,
        };
      });
      return {
        key: item?.key,
        title: item?.title,
        list,
      };
    });

    setPreviewData(newPreviewData);
  }, [selectedKeys, tableData]);

  useEffect(() => {
    if (releaseDetail) {
      const resData = cloneDeep(releaseDetail);

      const thisShowMode = resData?.histories?.find((item: any) => item.id === rId)?.showMode;
      const resShowMode = findDeep(release.show_mode_arr, thisShowMode);

      // 有升级场景，在新版本页面，按钮要受到旧版本状态影响
      if (resShowMode?.isUpgrade && resData?.histories?.length > 1) {
        const oldShowMode = resData?.histories[1]?.showMode;
        resData.baseBtns = resShowMode?.btnsByOld[oldShowMode];
      } else {
        resData.baseBtns = resShowMode?.baseBtns;
      }

      resData.showModeLabel = resShowMode?.title;
      resData.isUpgrade = !!resShowMode?.isUpgrade;

      if (resData?.appInstances[0]?.version) {
        resData.showModeLabel = resData?.appInstances[0]?.version + one_bars + resShowMode?.title;
      } else {
        resData.showModeLabel = "新版本-" + resShowMode?.title;
      }
      // 当存在两个版本时候，旧版本都不可修改
      if (resData?.histories?.length > 1 && resData?.histories[1]?.id === rId) {
        resData.disabled = true;
      } else {
        resData.disabled = resShowMode?.formDisabled;
      }

      resData.packageDisabled =
        resShowMode?.packageDisabled || (resShowMode?.modeObj && resShowMode?.modeObj[resData.mode]?.packageDisabled);
      resData.allowChangePackageList =
        resShowMode?.allowChangePackageList ||
        (resShowMode?.modeObj && resShowMode?.modeObj[resData.mode]?.allowChangePackageList);

      resData.opinion = resShowMode?.opinion;

      resData.modeTypeText = typeItem?.titlelabel;

      resData.titleDescriptionLabel = resShowMode?.titleDescription
        ? resShowMode?.pleaseWrite
          ? resShowMode?.pleaseWrite + typeItem?.completeLabel + resShowMode?.titleDescription
          : typeItem?.completeLabel + resShowMode?.titleDescription
        : "";

      detailData.current = resData;

      domainAndTopic();
      getOSVersionList();
      getSupportOptions();
    }
  }, [releaseDetail]);

  useEffect(() => {
    baseForm
      .validateFields({ validateOnly: true })
      .then(() => setIsBaseFinish(true))
      .catch(() => setIsBaseFinish(false));
  }, [baseFormValues]);
  useEffect(() => {
    versionForm
      .validateFields({ validateOnly: true })
      .then(() => setIsVersionFinish(true))
      .catch(() => setIsVersionFinish(false));
  }, [versionFormValues]);
  useEffect(() => {
    setPreviewCurrent(previewData);
    baseForm.setFieldValue("previewFormData", previewData);
    versionForm.setFieldValue("previewFormData", previewData);
  }, [previewData]);
  useEffect(() => {
    getReleaseDetail(type, rId);
  }, []);

  return (
    <div className={prefix}>
      <div className={`${prefix}-header`}>
        <div className={`${prefix}-header-left`}>
          <div title={detailData.current?.showModeLabel} className="one-line-ellipsis">
            {detailData.current?.showModeLabel}
          </div>
          {detailData.current?.titleDescriptionLabel ? <div>{detailData.current?.titleDescriptionLabel}</div> : null}
          <div className="one-line-ellipsis" title={detailData.current?.opinion || detailData.current?.audit?.content}>
            <span>{release.review_comments}</span>
            {detailData.current?.opinion || detailData.current?.audit?.content || two_bars}
          </div>
        </div>
        <div>
          {detailData.current?.baseBtns?.map((item: string) => {
            return <span key={item}>{renderBtn(item)}</span>;
          })}
        </div>
      </div>
      <div className={`${prefix}-content`}>
        <Tabs
          activeKey={activeKey}
          renderTabBar={renderTabBar}
          indicator={{ size: (origin) => origin - 19, align: "start" }}
          onChange={onChange}
          className={`${prefix}-tabs`}
          items={[
            {
              key: release.tabs[0].key,
              forceRender: true,
              label: (
                <>
                  {release.tabs[0].label}
                  {<CheckCircleFilled style={{ color: isBaseFinish ? "#3EC167" : "#8C8C8C", marginLeft: 4 }} />}
                </>
              ),
              children: (
                <Form
                  disabled={detailData.current?.disabled}
                  form={baseForm}
                  layout="vertical"
                  scrollToFirstError={true}
                  className={`${prefix}-baseForm ${prefix}-form`}
                >
                  <Form.Item
                    label={release.supported_devices_label}
                    name="previewFormData"
                    rules={[{ required: true, message: release.supported_devices_required }]}
                  >
                    <Table
                      columns={getTableColumns()}
                      dataSource={tableData}
                      pagination={false}
                      rowSelection={{
                        type: "checkbox",
                        hideSelectAll: detailData.current?.disabled,
                        ...rowSelection,
                      }}
                    />
                  </Form.Item>
                  <Form.Item
                    label={detailData.current?.modeTypeText + release.name_label}
                    name="name"
                    validateDebounce={500}
                    rules={[
                      { required: true, message: please_enter + detailData.current?.modeTypeText + name_label },
                      {
                        pattern: appNameReg,
                        message: app_detail.name_validator,
                      },
                      {
                        validator: vailIdName,
                      },
                    ]}
                    getValueFromEvent={(e) => e.target.value.replace(/(^\s*)|(\s*$)/g, "")}
                  >
                    <Input
                      placeholder={`${please_enter}${detailData.current?.modeTypeText}${name_label}`}
                      showCount
                      maxLength={30}
                      style={{ width: 524 }}
                    />
                  </Form.Item>
                  {isComponent ? null : (
                    <>
                      <Form.Item
                        label={release.introduction}
                        name="introduction"
                        validateDebounce={500}
                        rules={[{ required: true, message: release.introduction_required }]}
                        getValueFromEvent={(e) => e.target.value.replace(/(^\s*)|(\s*$)/g, "")}
                      >
                        <Input
                          placeholder={release.introduction_required}
                          showCount
                          maxLength={30}
                          style={{ width: 524 }}
                        />
                      </Form.Item>
                    </>
                  )}

                  <Form.Item
                    label={release.description_label}
                    name="description"
                    rules={[
                      {
                        required: true,
                        message: `${please_enter}${description_label}`,
                      },
                    ]}
                    // getValueFromEvent={(e) => e.target.value.replace(/\s/g, '')}
                  >
                    <Input.TextArea
                      placeholder={`${please_enter}${description_label}`}
                      showCount
                      maxLength={300}
                      autoSize={{ minRows: 4, maxRows: 6 }}
                      style={{ width: 524 }}
                    />
                  </Form.Item>
                  <Form.Item
                    label={release.icon_label}
                    name="iconResources"
                    rules={[
                      { required: true, message: `${please_upload}${detailData.current?.modeTypeText}${icon_text}` },
                    ]}
                    className={`${prefix}-baseForm-iconResources`}
                  >
                    <div>
                      <div className={`${prefix}-form-tip`}>{release.icon_tip}</div>
                      <Upload
                        accept="image/*"
                        listType="picture-card"
                        showUploadList={false}
                        disabled={detailData.current?.disabled || iconLoading}
                        maxCount={1}
                        action={uploadUrl}
                        headers={{
                          Authorization: getServiceVal("Authorization") || "",
                        }}
                        data={{
                          appId: rId,
                          type: "ICON",
                          subType: "ICON",
                        }}
                        beforeUpload={async (e) => {
                          await beforeUpload(e, { width: 256, height: 256, accept: ["png"] });
                        }}
                        onChange={iconImageChange}
                        style={{ margin: 0 }}
                      >
                        {iconImageUrl ? (
                          <img src={iconImageUrl} alt="avatar" />
                        ) : iconLoading ? (
                          <LoadingOutlined />
                        ) : (
                          <PlusSquareFilled className={`${prefix}-add-icon`} />
                        )}
                      </Upload>
                    </div>
                  </Form.Item>
                  {isComponent ? null : (
                    <>
                      <Form.Item
                        label={release.domain_label}
                        name="domain"
                        rules={[{ required: true, message: release.domain_required }]}
                      >
                        <Select
                          showSearch
                          options={domainOption}
                          placeholder={release.domain_required}
                          fieldNames={{ label: "dictLabel", value: "dictCode" }}
                          filterOption={(input, option) =>
                            (option?.dictLabel ?? "").toLowerCase().includes(input.toLowerCase())
                          }
                          style={{ width: 524 }}
                        />
                      </Form.Item>
                      <Form.Item
                        label={release.topic_label}
                        name="topic"
                        rules={[{ required: true, message: release.topic_required }]}
                      >
                        <Select
                          mode="multiple"
                          options={topicOption}
                          placeholder={release.topic_required}
                          fieldNames={{ label: "dictLabel", value: "dictCode" }}
                          filterOption={(input, option) =>
                            (option?.dictLabel ?? "").toLowerCase().includes(input.toLowerCase())
                          }
                          style={{ width: 524 }}
                        />
                      </Form.Item>
                      <Form.Item
                        label={release.preview_screenshot_label}
                        shouldUpdate={(prevValues, curValues) =>
                          prevValues.previewFormData !== curValues.previewFormData
                        }
                        rules={[{ required: true }]}
                      >
                        {({ getFieldValue }) => {
                          const pFormData: any[] = getFieldValue("previewFormData") || [];
                          return (
                            <div>
                              <div className={`${prefix}-form-tip`}>{release.preview_screenshot_tip}</div>
                              {pFormData.map((item, index) => (
                                <div key={item.key} className={`${prefix}-screenshot`}>
                                  <div className={`${prefix}-screenshot-title`}>{item.title}：</div>
                                  {item.list.map((ele: any, idx: number) => {
                                    return (
                                      <div key={ele.dictCode} className={`${prefix}-screenshot-device`}>
                                        <div className={`${prefix}-screenshot-device-title`}>{ele.dictLabel}：</div>
                                        {ele.urlList.map((e: any, i: number) => {
                                          return (
                                            <div key={e.id} className={`${prefix}-upload-img`}>
                                              {detailData.current?.disabled ? null : (
                                                <CloseCircleFilled
                                                  className={`${prefix}-upload-img-del`}
                                                  onClick={() => {
                                                    previewImgDelete(index, idx, i);
                                                  }}
                                                />
                                              )}

                                              <Upload
                                                accept="image/*"
                                                listType="picture-card"
                                                showUploadList={false}
                                                disabled={detailData.current?.disabled || e.loading}
                                                maxCount={1}
                                                action={uploadUrl}
                                                headers={{
                                                  Authorization: getServiceVal("Authorization") || "",
                                                }}
                                                data={{
                                                  appId: rId,
                                                  subType: ele.dictValue,
                                                  type: "PREVIEW_PICTURE",
                                                }}
                                                beforeUpload={async (e) => {
                                                  await beforeUpload(e, {
                                                    width: 1800,
                                                    height: 920,
                                                    size: 3145728,
                                                    accept: ["jpg", "jpeg", "png"],
                                                  });
                                                }}
                                                onChange={(e) => {
                                                  previewImgUpdate(e, index, idx, i);
                                                }}
                                              >
                                                {e.loading ? <LoadingOutlined /> : <img src={e?.url} alt="avatar" />}
                                              </Upload>
                                            </div>
                                          );
                                        })}
                                        {ele.urlList?.length >= 10 ? null : (
                                          <Upload
                                            accept="image/*"
                                            listType="picture-card"
                                            className={`${prefix}-upload-imgAdd`}
                                            disabled={detailData.current?.disabled || ele.loading}
                                            action={uploadUrl}
                                            headers={{
                                              Authorization: getServiceVal("Authorization") || "",
                                            }}
                                            data={{
                                              appId: rId,
                                              subType: ele.dictValue,
                                              type: "PREVIEW_PICTURE",
                                            }}
                                            showUploadList={false}
                                            beforeUpload={async (e) => {
                                              await beforeUpload(e, {
                                                width: 1800,
                                                height: 920,
                                                size: 3145728,
                                                accept: ["jpg", "jpeg", "png"],
                                              });
                                            }}
                                            onChange={(e) => {
                                              previewImgChange(e, index, idx);
                                            }}
                                          >
                                            {ele.loading ? (
                                              <LoadingOutlined />
                                            ) : (
                                              <PlusSquareFilled className={`${prefix}-add-icon`} />
                                            )}
                                          </Upload>
                                        )}
                                      </div>
                                    );
                                  })}
                                </div>
                              ))}
                            </div>
                          );
                        }}
                      </Form.Item>
                      <Form.Item
                        name="previewFormData"
                        className={`${prefix}-hidden`}
                        rules={[
                          { required: true, message: release.preview_screenshot_required },
                          ({ getFieldValue }) => ({
                            async validator() {
                              const previewList = getFieldValue("previewFormData");
                              const validatorSuccess = previewList?.every((item: any) => {
                                const listSuccess = item.list.every((ele: any) => {
                                  return ele.urlList?.length > 0;
                                });
                                return listSuccess;
                              });
                              if (!validatorSuccess) {
                                return Promise.reject(new Error(release.preview_screenshot_validator));
                              } else {
                                return Promise.resolve();
                              }
                            },
                          }),
                        ]}
                      >
                        <Input hidden />
                      </Form.Item>
                    </>
                  )}
                </Form>
              ),
            },
            {
              key: release.tabs[1].key,
              forceRender: true,
              label: (
                <>
                  {release.tabs[1].label}
                  {<CheckCircleFilled style={{ color: isVersionFinish ? "#3EC167" : "#8C8C8C", marginLeft: 4 }} />}
                </>
              ),
              children: (
                <Form
                  form={versionForm}
                  disabled={detailData.current?.disabled}
                  layout="vertical"
                  scrollToFirstError={true}
                  className={`${prefix}-versionForm ${prefix}-form`}
                >
                  {isComponent ? (
                    // 我的组件
                    <>
                      <Form.Item
                        label={release.package_label}
                        shouldUpdate={(prevValues, curValues) =>
                          prevValues.instanceResources !== curValues.instanceResources
                        }
                        rules={[{ required: true }]}
                        className={`${prefix}-versionForm-packageResources`}
                      >
                        {() => {
                          return (
                            <div>
                              <div className={`${prefix}-form-tip`}>{typeItem?.packageTip}</div>
                              <div className={`${prefix}-packageList`}>
                                {packageDataList?.map((item: any) => {
                                  return item?.resourceId ? (
                                    <div key={item.type} className={`${prefix}-package-data`} style={{ width: 524 }}>
                                      <span title={item?.name} className="one-line-ellipsis">
                                        {item?.name}
                                      </span>
                                      <span title={item?.version} className="one-line-ellipsis">
                                        {item?.version}
                                      </span>
                                      <span>{format(new Date(Number(item?.createTime)), "yyyy/MM/dd-HH:mm:ss")}</span>
                                      <span>{changeSize(item?.length)}</span>
                                      {detailData.current?.disabled || item?.disabled ? null : (
                                        <CloseCircleFilled
                                          style={{ color: "#000", cursor: "pointer" }}
                                          className={`${prefix}-package-del`}
                                          onClick={() => {
                                            packageListDel(item);
                                          }}
                                        />
                                      )}
                                    </div>
                                  ) : item?.loading ? (
                                    <div key={item.type} className={`${prefix}-package-loading`} style={{ width: 524 }}>
                                      <span title={item?.name} className="one-line-ellipsis">
                                        {item?.name}
                                      </span>
                                      {item?.uploadProgress < 100 ? (
                                        <span>
                                          {release.uploading_label}
                                          <Progress type="circle" size={30} percent={item?.uploadProgress} />
                                        </span>
                                      ) : (
                                        <span>
                                          {release.analysising_label}
                                          <LoadingOutlined style={{ color: "#0A59F7", fontSize: 30 }} />
                                        </span>
                                      )}
                                    </div>
                                  ) : (
                                    <div key={item.type} className={`${prefix}-upload-img`}>
                                      <Upload
                                        beforeUpload={packageBeforeUpload}
                                        customRequest={(e) => {
                                          packageListReq(e, item);
                                        }}
                                        showUploadList={false}
                                        disabled={detailData.current?.disabled || item?.disabled}
                                        style={{ margin: 0 }}
                                      >
                                        <div className={`${prefix}-package-add`}>
                                          <CloudUploadOutlined className={`${prefix}-package-cloud package-list`} />
                                          <span className={`${prefix}-package-label`}>{item.uploadLabel}</span>
                                          <PlusSquareFilled className={`${prefix}-package-plus`} />
                                        </div>
                                      </Upload>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          );
                        }}
                      </Form.Item>
                      <Form.Item
                        name="instanceResources"
                        className={`${prefix}-hidden instance-resources-hidden`}
                        rules={[
                          { required: true, message: release.packageList_required },
                          ({ getFieldValue }) => ({
                            async validator() {
                              const instanceResourcesList = getFieldValue("instanceResources");
                              const validatorSuccess = instanceResourcesList?.some((item: any) => item.resourceId);
                              if (!validatorSuccess) {
                                return Promise.reject(new Error(release.packageList_required));
                              } else {
                                return Promise.resolve();
                              }
                            },
                          }),
                        ]}
                      >
                        <Input hidden />
                      </Form.Item>
                      <Divider />
                      <Form.Item
                        label={typeItem.descriptionLabel}
                        shouldUpdate={(prevValues, curValues) =>
                          prevValues.previewFormData !== curValues.previewFormData
                        }
                        rules={[{ required: true }]}
                      >
                        {({ getFieldValue }) => {
                          const pFormData: any[] = getFieldValue("previewFormData") || [];

                          return pFormData?.map((item: any, index: number) => {
                            return (
                              <div key={item.key} className={`${prefix}-screenshot`}>
                                <div className={`${prefix}-screenshot-title`}>{item.title}：</div>
                                {item.list.map((ele: any, idx: number) => {
                                  return (
                                    <div key={ele.dictCode}>
                                      <div className={`${prefix}-screenshot-device-title`}>{ele.dictLabel}：</div>
                                      <Cascader
                                        style={{ width: 524 }}
                                        options={versionOptions}
                                        placeholder={please_choose}
                                        // maxTagCount="responsive"
                                        value={ele.osIds}
                                        showCheckedStrategy="SHOW_CHILD"
                                        getPopupContainer={(triggerNode) => triggerNode.parentElement}
                                        multiple
                                        popupClassName={`${prefix}-screenshot-cscader`}
                                        onChange={(v) => {
                                          previewDescriptionChange(v, index, idx);
                                        }}
                                      />
                                      {/* <Input.TextArea
                                            placeholder={please_enter}
                                            value={ele.description}
                                            showCount
                                            maxLength={100}
                                            autoSize={{ minRows: 4, maxRows: 6 }}
                                            onChange={(e) => {
                                              previewDescriptionChange(e, index, idx);
                                            }}
                                            style={{ width: 524 }}
                                          /> */}
                                    </div>
                                  );
                                })}
                              </div>
                            );
                          });
                        }}
                      </Form.Item>

                      <Form.Item
                        name="previewFormData"
                        className={`${prefix}-hidden`}
                        rules={[
                          { required: true, message: typeItem.descriptionMessage },
                          ({ getFieldValue }) => ({
                            async validator() {
                              const previewList = getFieldValue("previewFormData");
                              const validatorSuccess = previewList?.every((item: any) => {
                                const listSuccess = item.list.every((ele: any) => {
                                  // return !!ele.description;
                                  return ele.osIds?.length;
                                });
                                return listSuccess;
                              });
                              if (!validatorSuccess) {
                                return Promise.reject(new Error(typeItem.descriptionMessage));
                              } else {
                                return Promise.resolve();
                              }
                            },
                          }),
                        ]}
                      >
                        <Input hidden />
                      </Form.Item>
                      <Divider />
                    </>
                  ) : (
                    <>
                      <Form.Item
                        label={release.package_label}
                        name="instanceIds"
                        rules={[{ required: true, message: release.package_required }]}
                        className={`${prefix}-versionForm-packageResources`}
                      >
                        <div>
                          <div className={`${prefix}-form-tip`}>{typeItem?.packageTip}</div>
                          {packageData?.resourceId ? (
                            <div className={`${prefix}-package-data`} style={{ width: 524 }}>
                              <span title={packageData?.name} className="one-line-ellipsis">
                                {packageData?.name}
                              </span>
                              <span title={packageData?.version} className="one-line-ellipsis">
                                {packageData?.version}
                              </span>
                              <span>{format(new Date(Number(packageData?.createTime)), "yyyy/MM/dd-HH:mm:ss")}</span>
                              <span>{changeSize(packageData?.length)}</span>
                              {detailData.current?.disabled || detailData.current?.packageDisabled ? null : (
                                <CloseCircleFilled
                                  style={{ color: "#000", cursor: "pointer" }}
                                  className={`${prefix}-package-del`}
                                  onClick={packageDel}
                                />
                              )}
                            </div>
                          ) : packageLoading ? (
                            <div className={`${prefix}-package-loading`} style={{ width: 524 }}>
                              <span title={packageData?.name} className="one-line-ellipsis">
                                {packageData?.name}
                              </span>
                              {uploadProgress < 100 ? (
                                <span>
                                  {release.uploading_label}
                                  <Progress type="circle" size={30} percent={uploadProgress} />
                                </span>
                              ) : (
                                <span>
                                  {release.analysising_label}
                                  <LoadingOutlined style={{ color: "#0A59F7", fontSize: 30 }} />
                                </span>
                              )}
                            </div>
                          ) : (
                            <Upload
                              beforeUpload={packageBeforeUpload}
                              customRequest={packageReq}
                              showUploadList={false}
                              style={{ margin: 0 }}
                            >
                              <div className={`${prefix}-package-add`}>
                                <CloudUploadOutlined className={`${prefix}-package-cloud`} />
                                <PlusSquareFilled className={`${prefix}-package-plus`} />
                              </div>
                            </Upload>
                          )}
                        </div>
                      </Form.Item>
                      <Divider />
                    </>
                  )}

                  <Form.Item
                    label={release.privacy_label}
                    name="privacy"
                    rules={[
                      { required: true, message: release.privacy_label_required },
                      {
                        pattern: /(http|https):\/\/([\w.]+\/?)\S*/,
                        message: release.privacy_validator,
                      },
                    ]}
                    getValueFromEvent={(e) => e.target.value.replace(/(^\s*)|(\s*$)/g, "")}
                  >
                    <Input placeholder={release.privacy_placeholder} maxLength={1024} style={{ width: 524 }} />
                  </Form.Item>
                  {isComponent ? null : (
                    <>
                      <Divider />
                      <Form.Item
                        label={release.version_label}
                        name="agree"
                        className={`${prefix}-versionForm-agree`}
                        valuePropName="checked"
                        rules={[{ required: true, message: "" }]}
                      >
                        <div>
                          <div className={`${prefix}-form-tip`}>{release.version_tip}</div>
                          <div className={`${prefix}-agree-wrap`}>
                            {release.commitment_letter_label}
                            <Checkbox
                              className={`${prefix}-agree-checkbox`}
                              checked={agreeCheck}
                              onChange={agreeChange}
                            >
                              {release.read_agree}
                              <Button type="link" onClick={commitmentLetter} className={`${prefix}-agree-btn`}>
                                {release.commitment_letter_book}
                              </Button>
                            </Checkbox>
                          </div>
                        </div>
                      </Form.Item>

                      <Form.Item
                        label={release.copyright_label}
                        name="copyright"
                        rules={[{ required: true, message: release.copyright_required }]}
                        className={`${prefix}-versionForm-copyright`}
                      >
                        <div className="clearfix">
                          {copyrightImage?.map((item: any, index: number) => {
                            return (
                              <div key={item.id} className={`${prefix}-upload-img`}>
                                {detailData.current?.disabled ? null : (
                                  <CloseCircleFilled
                                    className={`${prefix}-upload-img-del`}
                                    onClick={() => {
                                      copyrightImgDelete(index);
                                    }}
                                  />
                                )}

                                <Upload
                                  accept="image/*"
                                  listType="picture-card"
                                  className={`${prefix}-copyright-upload`}
                                  disabled={detailData.current?.disabled || item.loading}
                                  action={uploadUrl}
                                  headers={{
                                    Authorization: getServiceVal("Authorization") || "",
                                  }}
                                  data={{
                                    appId: rId,
                                    type: "CERTIFICATE_PICTURE",
                                    subType: "CERTIFICATE_PICTURE",
                                  }}
                                  showUploadList={false}
                                  onChange={(e) => {
                                    copyrightImgUpdate(e, index);
                                  }}
                                >
                                  {item.loading ? <LoadingOutlined /> : <img src={item?.url} alt="avatar" />}
                                </Upload>
                              </div>
                            );
                          })}
                          {copyrightImage?.length >= 10 ? null : (
                            <Upload
                              accept="image/*"
                              listType="picture-card"
                              className={`${prefix}-upload-imgAdd`}
                              disabled={detailData.current?.disabled || copyrightLoading}
                              action={uploadUrl}
                              headers={{
                                Authorization: getServiceVal("Authorization") || "",
                              }}
                              data={{
                                appId: rId,
                                type: "CERTIFICATE_PICTURE",
                                subType: "CERTIFICATE_PICTURE",
                              }}
                              showUploadList={false}
                              beforeUpload={copyrightBeforeUpload}
                              onChange={copyrightImgChange}
                            >
                              {copyrightLoading ? (
                                <LoadingOutlined />
                              ) : (
                                <PlusSquareFilled className={`${prefix}-add-icon`} />
                              )}
                            </Upload>
                          )}
                        </div>
                      </Form.Item>
                    </>
                  )}
                </Form>
              ),
            },
          ]}
        />
      </div>
      <ApplyDown type={type} id={rId} visible={applyDownVisible} close={applyDownClose} />
    </div>
  );
};

export default Release;
